// polyfill for browsers (see https://angular.io/docs/ts/latest/guide/webpack.html)
import 'core-js/es6'
import 'core-js/es7/reflect'
require('zone.js/dist/zone')

// safari
import 'intl'
import 'intl/locale-data/jsonp/en'

if (process.env.ENV === 'production') {
    // Production
} else {
  // Development and test
  Error['stackTraceLimit'] = Infinity
  require('zone.js/dist/long-stack-trace-zone')
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./polyfill.ts